import { render, staticRenderFns } from "./AnnotationContext.vue?vue&type=template&id=c7d1a56e"
import script from "./AnnotationContext.vue?vue&type=script&lang=js"
export * from "./AnnotationContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports